var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter-like",staticStyle:{"display":"flex"}},[_c('div',{staticClass:"icon-heart",class:{"icon-like-active": _vm.countLike > 0},attrs:{"id":_vm.idElement}}),(_vm.countLike > 0)?_c('div',{staticClass:"count-favorites",staticStyle:{"margin-top":"-2px","margin-left":"2px"}},[_vm._v(_vm._s(_vm.countLike))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }